import React, { Component } from "react"
import { css } from "emotion"
import DefaultLayout from "../template/default-layout"
import PostImage from "../post-image"
import { Helmet } from "react-helmet"

class PostTemplate extends Component {
  render() {
    const post = this.props.data.wordpressPost
    return (
      <DefaultLayout>
        <Helmet>
          <title>{post.title}</title>
        </Helmet>
        <div className="banner">
          <div className="wrapper">
            <h1
              dangerouslySetInnerHTML={{ __html: post.title }}
              className={css`
                font-size: 44px;
              `}
            />
          </div>
        </div>

        <div className="wrapper">
          <PostImage node={post} />

          <div
            dangerouslySetInnerHTML={{ __html: post.content }}
            className={css`
              padding: 20px 10px;

              p {
                font-size: 18px;
                line-height: 22px;
                padding: 10px 5px;

                strong {
                  font-weight: bold;
                }
              }

              p [content="&nbsp"] {
                background-color: red;
              }

              ol,
              ul {
                list-style: disc;
                font-size: 18px;
                margin: 10px 20px;
                position: relative;
                list-style-position: outside;

                li {
                  line-height: 30px;

                  em {
                    font-style: italic;
                  }
                }
              }
            `}
          />
        </div>
      </DefaultLayout>
    )
  }
}

// PostTemplate.propTypes = {
//   data: PropTypes.object.isRequired,
//   edges: PropTypes.array,
// }

export default PostTemplate

export const pageQuery = graphql`
  query($id: String!) {
    wordpressPost(id: { eq: $id }) {
      title
      content
      featured_media {
        media_details {
          file
        }
      }
    }
  }
`
